import CloseLesson from './CloseLesson';

export default CloseLesson;
